import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { FaEnvelope, FaPaperPlane, FaArrowLeft, FaTruck } from 'react-icons/fa';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }
    
    try {
      setIsLoading(true);
      await resetPassword(email);
      setIsSubmitted(true);
      toast.success('Password reset email sent. Check your inbox!');
    } catch (error) {
      toast.error(error.message || 'Failed to send reset email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="forgot-card">
        <div className="forgot-header">
          <div className="logo-container">
            <FaTruck className="logo-icon" />
          </div>
          <h1 className="company-name">Reset your password</h1>
          <p className="forgot-subtitle">
            {isSubmitted 
              ? 'Check your email for reset instructions' 
              : 'Enter your email to receive a password reset link'}
          </p>
        </div>
        
        <div className="forgot-form-container">
          {!isSubmitted ? (
            <form className="forgot-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email-address" className="form-label">Email address</label>
                <div className="input-container">
                  <div className="input-icon">
                    <FaEnvelope />
                  </div>
                  <input
                    id="email-address"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="form-input"
                    placeholder="you@example.com"
                    value={email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-submit">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="forgot-button"
                >
                  {isLoading ? (
                    <span className="loading-indicator">
                      <svg
                        className="spinner"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      <span>Sending...</span>
                    </span>
                  ) : (
                    <span className="button-content">
                      <FaPaperPlane className="button-icon" />
                      <span>Send Reset Link</span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          ) : (
            <div className="success-container">
              <div className="email-icon-container">
                <FaEnvelope size={24} />
              </div>
              <p className="success-message">
                We've sent a password reset link to:
              </p>
              <p className="email-address">{email}</p>
              <p className="success-message">
                Please check your inbox and follow the instructions to reset your password.
              </p>
              <button 
                type="button"
                onClick={handleSubmit}
                className="resend-button"
              >
                <FaPaperPlane className="button-icon" />
                Resend email
              </button>
            </div>
          )}
        </div>
        
        <div className="forgot-footer">
          <Link 
            to="/login" 
            className="back-link"
          >
            <FaArrowLeft className="back-icon" />
            Return to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;